import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ConnectionTypesSharedModule } from 'app/connection-types/connection-types-shared.module';
import { FieldSharedModule } from 'app/field-shared/field-shared.module';
import { NoteModule } from 'app/note/note.module';
import { ToplinesModule } from 'app/toplines/toplines.module';
import { AssessmentSharedModule } from 'assessment/assessment-shared.module';
import { SharedModule } from 'shared/shared.module';

import { CreateEntityComponent } from './components/create-entity/create-entity.component';
import {
  EntityActionBoxComponent
} from './components/entity-action-box/entity-action-box.component';
import {
  EntityAddressesTableComponent
} from './components/entity-addresses-table/entity-addresses-table.component';
import {
  EntityAssessmentAddComponent
} from './components/entity-assessment-add/entity-assessment-add.component';
import {
  EntityAutocompleteComponent
} from './components/entity-autocomplete/entity-autocomplete.component';
import { EntityAvatarComponent } from './components/entity-avatar/entity-avatar.component';
import {
  EntityBackButtonComponent
} from './components/entity-back-button/entity-back-button.component';
import {
  EntityBasicCardComponent
} from './components/entity-basic-card/entity-basic-card.component';
import {
  EntityContactToplinesComponent
} from './components/entity-contact-toplines/entity-contact-toplines.component';
import {
  EntityConnectionAppliedTagsComponent
} from './components/entity-connection-applied-tags/entity-connection-applied-tags.component';
import {
  EntityConnectionLazyContentComponent
} from './components/entity-connection-table/entity-connection-lazy-content/entity-connection-lazy-content.component';
import {
  EntityConnectionRowComponent
} from './components/entity-connection-table/entity-connection-row/entity-connection-row.component';
import {
  EntityConnectionTableComponent
} from './components/entity-connection-table/entity-connection-table.component';
import {
  EntityContactButtonsComponent
} from './components/entity-contact-buttons/entity-contact-buttons.component';
import {
  EntityDobTableComponent
} from './components/entity-dob-table/entity-dob-table.component';
import {
  EntityDuplicatesComponent
} from './components/entity-duplicates/entity-duplicates.component';
import {
  EntityEmailsTableComponent
} from './components/entity-emails-table/entity-emails-table.component';
import {
  EntityFlagTableComponent
} from './components/entity-flag-table/entity-flag-table.component';
import {
  EntityFollowUpFlagComponent
} from './components/entity-follow-up-flag/entity-follow-up-flag.component';
import { EntityIdsComponent } from './components/entity-ids/entity-ids.component';
import {
  EntityLanguageTableComponent
} from './components/entity-language-table/entity-language-table.component';
import { EntityListRowComponent } from './components/entity-list-row/entity-list-row.component';
import {
  EntityNameTableComponent
} from './components/entity-name-table/entity-name-table.component';
import {
  EntityPhonesTableComponent
} from './components/entity-phones-table/entity-phones-table.component';

import {
  EntitySimpleCardComponent
} from './components/entity-simple-card/entity-simple-card.component';
import {
  EntitySocialTableComponent
} from './components/entity-social-table/entity-social-table.component';
import {
  EntityTabbedCardComponent
} from './components/entity-tabbed-card/entity-tabbed-card.component';
import { EntityToplinesComponent } from './components/entity-toplines/entity-toplines.component';
import {
  EntityUserStatusComponent
} from './components/entity-user-status/entity-user-status.component';
import { AddAssessmentDialog } from './dialogs/add-assessment/add-assessment.dialog';
import { AddConnectionDialog } from './dialogs/add-connection/add-connection.dialog';
import {
  AddOrUpdateAddressDialog
} from './dialogs/add-or-update-address/add-or-update-address.dialog';
import {
  AddOrUpdateDOBDialog
} from './dialogs/add-or-update-dob/add-or-update-dob.dialog';

import {
  AddOrUpdateLanguageDialog
} from './dialogs/add-or-update-language/add-or-update-language.dialog';
import { AddOrUpdateEmailDialog } from './dialogs/add-or-update-email/add-or-update-email.dialog';
import { AddOrUpdateNameDialog } from './dialogs/add-or-update-name/add-or-update-name.dialog';
import { AddOrUpdatePhoneDialog } from './dialogs/add-or-update-phone/add-or-update-phone.dialog';
import {
  AddOrUpdateSocialDialog
} from './dialogs/add-or-update-social/add-or-update-social.dialog';
import { CreateEntityDialog } from './dialogs/create-entity/create-entity.dialog';
import { EntityQuickEditDialog } from './dialogs/quick-edit/entity-quick-edit.dialog';
import { FollowUpFlagDialog } from './dialogs/follow-up-flag/follow-up-flag.dialog';
import { FollowUpFlagDueDateDialog } from './dialogs/follow-up-flag-due-date/follow-up-flag-due-date.dialog';
import { ReassignFollowUpFlagDialog } from './dialogs/reassign-follow-up-flag/reassign-follow-up-flag.dialog';
import { FollowUpTableDialog } from './dialogs/follow-up-table/follow-up-table.dialog';
import { MergeEntitiesDialog } from './dialogs/merge-entities/merge-entities.dialog';
import { PotentialDuplicateDialog } from './dialogs/potential-duplicate/potential-duplicate.dialog';
import { SharedContactInfoDialog } from './dialogs/shared-contact-info/shared-contact-info.dialog';
import { UpdateCustomIdDialog } from './dialogs/update-custom-id/update-custom-id.dialog';
import { DOBFormComponent } from './forms/dob-form/dob-form.component';
import { LanguageFormComponent } from './forms/language-form/language-form.component';
import { EmailFormComponent } from './forms/email-form/email-form.component';
import { NameFormComponent } from './forms/name-form/name-form.component';
import { PhoneFormComponent } from './forms/phone-form/phone-form.component';
import { EntityNameComponent } from './components/entity-name/entity-name.component';
import { CustomFormRendererComponent } from './components/custom-form-renderer/custom-form-renderer.component';
import { CreateConnectionFormComponent } from './forms/create-connection-form/create-connection-form.component';

const FORMS = [
  DOBFormComponent,
  EmailFormComponent,
  LanguageFormComponent,
  NameFormComponent,
  PhoneFormComponent,
  CreateConnectionFormComponent
];

const COMPONENTS = [
  CreateEntityComponent,
  CustomFormRendererComponent,
  EntityActionBoxComponent,
  EntityAddressesTableComponent,
  EntityAssessmentAddComponent,
  EntityAutocompleteComponent,
  EntityAvatarComponent,
  EntityBackButtonComponent,
  EntityBasicCardComponent,
  EntityContactToplinesComponent,
  EntityConnectionAppliedTagsComponent,
  EntityConnectionLazyContentComponent,
  EntityConnectionRowComponent,
  EntityConnectionTableComponent,
  EntityContactButtonsComponent,
  EntityDobTableComponent,
  EntityDuplicatesComponent,
  EntityEmailsTableComponent,
  EntityFlagTableComponent,
  EntityFollowUpFlagComponent,
  EntityIdsComponent,
  EntityLanguageTableComponent,
  EntityListRowComponent, // LIST
  EntityNameComponent,
  EntityNameTableComponent,
  EntityPhonesTableComponent,
  EntitySimpleCardComponent,
  EntitySocialTableComponent,
  EntityTabbedCardComponent,
  EntityToplinesComponent,
  EntityUserStatusComponent
];

const DIALOGS = [
  AddAssessmentDialog,
  AddConnectionDialog,
  AddOrUpdateAddressDialog,
  AddOrUpdateDOBDialog,
  AddOrUpdateEmailDialog,
  AddOrUpdateLanguageDialog,
  AddOrUpdateNameDialog,
  AddOrUpdatePhoneDialog,
  AddOrUpdateSocialDialog,
  CreateEntityDialog,
  ReassignFollowUpFlagDialog,
  EntityQuickEditDialog,
  FollowUpFlagDueDateDialog,
  FollowUpFlagDialog,
  FollowUpTableDialog,
  MergeEntitiesDialog,
  PotentialDuplicateDialog,
  SharedContactInfoDialog,
  UpdateCustomIdDialog
];

@NgModule({
  imports: [
    AssessmentSharedModule,
    ConnectionTypesSharedModule,
    FieldSharedModule,
    NoteModule,
    RouterModule,
    SharedModule,
    ToplinesModule,
  ],
  exports: [
    ...COMPONENTS,
    ...DIALOGS,
    ...FORMS,
    AssessmentSharedModule,
    ConnectionTypesSharedModule,
    FieldSharedModule,
    NoteModule,
    SharedModule,
    ToplinesModule
  ],
  declarations: [
    ...COMPONENTS,
    ...DIALOGS,
    ...FORMS,
  ],
  providers: []
})
export class EntityCoreModule { }
